import { useQuery } from "@tanstack/react-query";
import { FilterProps } from "../../types/AppTypes";
import { useNotification } from "../notification.hook";
import { PotentialMatrixFilters } from "../usePotentialMatrixFilters.hook";
import PotentialMatrixGeneralService from "../../services/api/potentialMatrix/PotentialMatrixGeneral.service";
import { RefreshReactQuery } from "../../constants/AppConstants";
import { useEffect } from "react";
import { ERROR_LABEL, ERROR_MESSAGE_LABEL } from "../../constants/Dictionary";

interface usePotentialMatrixGeneralProps {
  filters: PotentialMatrixFilters;
  createQueryParams: () => FilterProps[];
  enabled: boolean;
}

export const usePotentialMatrixGeneral = ({
  filters,
  createQueryParams,
  enabled,
}: usePotentialMatrixGeneralProps) => {
  const { notification } = useNotification();
  const { data, isLoading, isFetching, isError } = useQuery({
    queryKey: ["get-potential-matrix-general", filters],
    queryFn: ({ signal }) =>
      PotentialMatrixGeneralService.get(createQueryParams(), signal),
    staleTime: RefreshReactQuery.MODERATE,
    enabled,
  });

  useEffect(() => {
    if (isError) {
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    }
  }, [isError]);

  return { data, isLoading, isFetching };
};
